export const SIMPLE_PIN_MESSAGE =
  "PIN cannot contain repeated or sequential digits.";

export function isSimplePin(pin: unknown): boolean {
  if (typeof pin !== "string") return false;

  const value = pin.trim();
  if (!/^\d{2,}$/.test(value)) return false;

  if (/^(\d)\1+$/.test(value)) return true;

  const digits = value.split("").map(Number);
  const isAscending = digits.every(
    (digit, index) => index === 0 || digit === (digits[index - 1] + 1) % 10
  );
  const isDescending = digits.every(
    (digit, index) =>
      index === 0 || digit === (digits[index - 1] + 9) % 10
  );

  return isAscending || isDescending;
}
